// extracted by mini-css-extract-plugin
module.exports = {"text":"Account_text__2S9jc","textLarge":"Account_textLarge__AjYpL","textSmall":"Account_textSmall__FcToc"};